import { createContext } from "react";

export const SummaryContext = createContext({});